import {gql} from '@apollo/client';

export const MENTIONED_IN_ACTIVITY_SUBSCRIPTION = gql`
    subscription MentionedInActivity($userId: String!) {
        mentionedInActivity(userId: $userId)
    }
`;

export const ON_NOTIFICATION_SUBSCRIPTION = gql`
    subscription OnNotification($userId: String!) {
        onNotification(userId: $userId) {
            message
            level
            actionKey
            actionParams
            actionLabel
            actionUrl
        }
    }
`;
